export const CommonOktaStyling = {
  'TEXT_ALIGN_LEFT': 'left',
  'TEXT_ALIGN_CENTER': 'center',
  'TEXT_ALIGN_START': 'start',
  'TEXT_TRANSFORM_UPPERCASE':'uppercase',
  'TEXT_DECORATION_UNDERLINE':'underline',
  'TEXT_DECORATION_NONE':'none',
  'TEXT_COLOR_GREY': '#4F4F4F',
  'TEXT_COLOR_BLACK': '#000000',
  'TEXT_COLOR_BLUE': '#1A76C5',
  'BOX_SHADOW': 'rgba(0, 0, 0, 0.2) 0px 2px 8px 2px inset',
  'FONT_WEIGHT_LIGHT': '400',
  'FONT_WEIGHT_SEMI_BOLD': '600',
  'FONT_WEIGHT_BOLD': '700',
  'FONT_SIZE_SM': '16px',
  'FONT_SIZE_SL':'18px',
  'FONT_SIZE_L': '20px',
  'FONT_SIZE_S':'14px',
  'BORDER_NONE':'0px',
  'BORDER': '1px',
  'BORDER_RADIUS':'4px',
  'BACKGROUND_COLOR_BUTTON': 'linear-gradient(270deg, #F0B323 0%, #FED141 49.46%, #FED141 99.92%)',
  'PADDING_BOX':'16px 16px 16px 16px',
  'PADDING':'8px 24px',
  'MARGIN_NONE': '0px',
  'MARGIN_XS': '10px',
  'MARGIN_SM': '15px',
  'MARGIN_SM_NONE': '15px 0px',
  'MARGIN_L': '25px',
  'HEIGHT_L':'42px',
  'LINE_HEIGHT_S':'18px',
  'LINE_HEIGHT_M':'20px',
  'LINE_HEIGHT_L':'24px',
};